import type { MemberDataFirestoreRecord } from "@albertine/types";
import { PREFER_NOT_TO_USE_TITLE } from "@albertine/types";

export function formatMemberName(member: MemberDataFirestoreRecord): string {
    if (member.title && member.title !== PREFER_NOT_TO_USE_TITLE) {
        return `${member.title} ${member.lastName}`;
    }
    return `${member.firstName} ${member.lastName}`;
}
